import apiClient from './client'
import { CreateListingPayload } from '@/lib/validations/listing'

export const createListing = async (data: CreateListingPayload) => {
  const response = await apiClient.post('/listings', data)
  return response.data
}

export const getListings = async () => {
  const response = await apiClient.get('/listings')
  return response.data
}

export const getListingById = async (id: string) => {
  const response = await apiClient.get(`/listings/${id}`)
  return response.data
}

export const updateListing = async (id: string, data: Partial<CreateListingPayload>) => {
  const response = await apiClient.put(`/listings/${id}`, data)
  return response.data
}

export const deleteListing = async (id: string) => {
  const response = await apiClient.delete(`/listings/${id}`)
  return response.data
}

export const getListingsByType = async (listingType: string) => {
  const response = await apiClient.get(`/listings/type/${listingType}`)
  return response.data
}

export const getUserListings = async (userId: string) => {
  const response = await apiClient.get(`/listings/user/${userId}`)
  return response.data
}

// Favorites API
export const getUserFavorites = async () => {
  const response = await apiClient.get('/user/favorites')
  return response.data
}

export const addFavorite = async (listingId: string) => {
  const response = await apiClient.post(`/user/favorites/${listingId}`)
  return response.data
}

export const removeFavorite = async (listingId: string) => {
  const response = await apiClient.delete(`/user/favorites/${listingId}`)
  return response.data
}

export const checkIsFavorite = async (listingId: string): Promise<boolean> => {
  try {
    const response = await apiClient.get(`/user/favorites/${listingId}`)
    return response.data?.isFavorite ?? false
  } catch {
    return false
  }
}
